
const CheckedIcon = () => {
    return (
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPMobileFlyoutTrayJobDetailCopy12" transform="translate(-27, -491)" strokeWidth="2">
                    <g id="Group39Copy" transform="translate(7, 358)">
                        <g id="Group4" transform="translate(21, 134)">
                            <rect id="RectangleCopy12" stroke="#000000" fill="#000000" x="0" y="0" width="18" height="18" rx="3"></rect>
                            <polyline id="Stroke258" stroke="#FFFFFF" points="14.26 5 7.142 12.452 4 9.415"></polyline>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default CheckedIcon;
